//簡體中文
module.exports = {
    Message: {       //消息通知類
        callResult: {
            requestFailed: "請求失敗",
            error: "錯誤"
        },
        permission: {       //權限
            error: "沒有權限"
        },
        save: {       //保存
            success: "保存成功",
            error: "保存失敗",
            hasInfoEmpty: "存在必填信息為空",
            nameEmpty: "名稱不能為空",
            categoryIdEmpty: "專題不能為空",
        },
        remove: {       //刪除,
            confirmTitle: "刪除確認",
            confirmTip: "請在輸入框輸入「{confirm}」，然後點擊「刪除」按鈕進行刪除",
            confirm: "確認刪除",
            success: "刪除成功",
            error: "刪除失敗",
            batch: {    //批量刪除
                none: "請選擇要刪除的直播間",      //選擇列表為空
                isPush: "有直播間正在直播，請勿刪除"     //有直播間推流中
            },
            living: "該直播間正在直播，請勿刪除",
            commentConfirm: "確認刪除該評論嗎?",
            commentEmpty: "請選擇要刪除的評論"
        },
        update: {       //修改
            success: "修改成功",
            error: "修改失敗"
        },
        refresh: {
            success: "刷新成功",
            error: "刷新失敗",
        },
        copy: {
            success: "複製成功",
            error: "複製失敗",
            nonsupport: "該瀏覽器不支持自動複製"
        },
        result: "結果",
        info: "信息",
        placeholder: "搜索",
        placeholderSelect: "請選擇",
        enterInteger: "請輸入正整數",
        notempty: "不能為空",
        saveNum: "總訪問量不能小於實際訪問總量，當前直播間實際訪問總量為",
        explainEmpty: "（無）",
        uitext: "暫無",
        noData: "暫無數據",
        updateVodFlag: "是否將CMS後台對應稿件的直播狀態切換至「{status}」?",
        updateVodFlag_nfplus: "是否同步直播狀態",
        publishRecord: {
            confirm: "素材已入庫，是否再次入庫？",
            success: "入庫成功",
            error: "入庫失敗"
        },
        operation: {
            success: "操作成功",
            error: "操作失敗"
        },
        selectImg: "請選擇圖片",
        download: { error: "獲取下載地址失敗" },
        set: {
            success: "設置成功",
            error: "設置失敗",
            confirmHead: "確定要",
            watermarkConfirmTail: "水印嗎？",
            templateConfirmTail: "模版嗎？"
        },
        multiLive: {
            syncRoomImage: {
                error: "同步失敗"
            }
        }
    },
    Button: {       //按鈕名
        save: "保存",
        remove: "刪除",
        cancel: "取消",
        back: "返回",
        confirm: "確定",
        refresh: "刷新",
        preview: "預覽",
        edit: "編輯",
        copy: {
            common: "複製",
            shortUrl: "複製頁面地址",
            playerUrl: "複製播放器地址",
            commonCode: "複製通用代碼",
        },
        uploadImg: "選擇圖片",
        backToLiveRoomList: "返回直播間列表",
        labelMine: "我的",
        userGroup: "用戶組",
        department: "部門",
        uploadRecord: "上傳錄像",
        uploadCoverImage: "上傳封面圖",
        videoRef: "關聯素材庫",
        selectAll: "全選",
        start: "開啟",
        close: "關閉",
        add: "添加",
        moreInfo: "更多...",
        download: "下載鏈接",
        publish: "發布",
        setDefault: "設為默認",
        cancelDefault: "取消默認",
        stop: "停止"
    },
    Tag: {
        tagDefault: "默認"
    },
    title: {        //頁面標題
        jstest: "融媒體 • 直播雲平台"
    },
    loginText: "登錄中...",
    platformTitle: "融媒體 • 直播雲平台",    //頂部欄標題
    router: {       //路由標題
        noPermission: "賬號暫無直播系統訪問權限，請聯係管理員授權！",
        liveRoom_list: {
            all: "直播間列表",
            detail: "直播間詳情",
            edit: "編輯直播間",
            videoRef: "關聯作品"
        },
        live_category: {
            all: "直播專題",
            refLiveRoomAll: "關聯直播間列表",
            refLiveRoomDetail: "直播間詳情",
            refLiveRoomEdit: "編輯直播間",
            refLiveRoomVideoRef: "關聯作品"
        },
        related_report: {
            all: "相關報道",
            detail: "報道詳情"
        },
        live_record: "直播記錄",
        material_management: {
            all: "素材管理",
            material: "素材列表"
        },
        watermark_management: {
            all: "水印管理",
            detail: "水印詳情"
        },
        director: {
            all: "雲導播",
            slow: "慢直播導播",
            vr: "VR導播",
        },
        department_template: {
            all: "部門模板",
            detail: "模版詳情",
            detailCopy: "複製模板"
        },
        material_template: {
            all: "素材模板",
            detail: "模版詳情",
            detailCopy: "複製模板"
        },
        cloud_editor: {
            all: "雲編輯",
            outputTask: "雲編輯輸出任務"
        },
        real_editor: "實時編輯",
        virtual_office: "雲演播",
        virtual_office_template: {
            all: "雲演播廳模板",
            detail: "雲演播廳模板詳情",
            management: "雲演播廳模板管理"
        },
        hard_encoder: {
            all: "硬件管理",
            detail: "硬件管理詳情"
        }
    },
    Const: {
        Result: {
            Success: "成功",
            InvalidParam: "參數錯誤",
            NoData: "無數據",
            Offline: "請求失敗"
        },
        Material: {
            Type: {
                Video: "視頻",
                Audio: "音頻",
                Image: "圖片"
            },
            Status: {
                Init: "未啟動",
                Init2: "初始",
                Done: "轉碼完成",
                Uploading: "上傳中",
                Defeated: "失敗",
                Progress: "轉碼中",
                ProgDefeated: "轉碼失敗",
                OssIdle: "oss待上傳",
                OssUploading: "oss上傳中",
                OssDefeated: "oss上傳失敗",
                GetInfo: "獲取視頻信息",
                GetAudioInfo: "獲取音頻信息"
            },
            PublishStatus: {
                Init: "初始",
                Defeated: "失敗",
                Issue: "已發布",
                Uploading3: "上傳中",
                Uploading4: "上傳中",
                Publishing: "發布中"
            }
        },
        Watermark: {
            Type: {
                Image: "圖片",
                Text: "文字"
            }
        },
        liveRoom: {
            publishStatus: {
                Issue: "已發布",
                Close: "未發布"
            },
            Comment: {
                Issue: "已發布",
                Shield: "未發布"
            },
            VodFlag: {
                Live: "直播",
                PlaybackOpen: "回顧",
                PlaybackClose: "回顧關閉",
                Trailer: "預告"
            },
            RecordType: {
                UploadRecord: "上傳錄像",
                LiveRecord: "直播錄像",
                transcodeRecord: "合成錄像",
                CloudEditorOutPut: "雲編輯輸出",
                refVideo: "關聯素材",
                recordVideo: "錄製錄像",
                SegmentRecord: "分段錄製錄像",
                TimelapseRecord: "延時錄像(抽幀)"
            },
            liveRecordTaskStatus: {
                Init: "未錄製",
                Starting: "啟動中",
                Recording: "錄製中",
                Stop: "未錄製"
            }
        },
        Record: {
            PublishStatus: {
                Init: "未入庫",
                Error: "入庫失敗",
                Success: "已入庫",
                updateVideo: "入庫中",
                updateImage: "入庫中",
                Push: "入庫中"
            }
        },
        Goods: {
            State: {
                Offline: "下架",
                Online: "上架"
            }
        }
    },
    Main: {
        auditStatusText: "用戶未通過實名認證，需要認證後才能使用此功能，5秒鐘後跳轉至用戶認證頁面",
        auditStatusMessageTitle: "跳轉失敗",
        auditStatusMessageDesc: "用戶未通過實名認證，認證後才可以使用此功能！",
    },
    Home: {     //主頁
        message: {
            upload: {
                success: "添加素材成功",
                error: "添加素材失敗"
            }
        },
        Header: {       //頂部欄
            contentMain: "融媒體 • 直播雲平台",
            liveCms: "直播",
            materialCms: "素材中心",
            department: "部門 ",
            userCms: "用戶中心：",
            adminCenter: "管理員中心",
            adminCenterDayoo: "審核中心",
            outRegistrationSystem: "報名系統",
            liveApp: {
                title: "APP下載",
                poptipTitle: "手機直播APP下載"
            },
            logout: "退出"
        },
        Sider: {        //側邊欄
            mainTitle: "雲直播",
            liveRoomManagement: {
                title: "直播間管理",
                liveRoomList: "直播間列表",
                liveRoomCategory: "直播專題",
                relatedReport: "相關報道",
                liveRecord: "直播記錄",
            },
            materialManagement: { title: "素材管理" },
            watermarkManagement: { title: "圖文水印" },
            directorManagement: {
                title: "雲導播管理",
                director: "雲導播",
                departmentTemplate: "部門模板",
                materialTemplate: "素材模板",
            },
            cloudEditor: { title: "雲編輯" },
            realEditor: { title: "實時編輯" },
            virtualOfficeManagement: {
                title: "雲演播管理",
                virtualOffice: "雲演播",
                virtualOfficeTemplate: "雲演播廳模板"
            },
            hardEncoder: { title: "硬件管理" }
        },
        uploadNotice: {
            success: "添加素材成功",
            error: "添加素材失敗"
        }
    },
    liveRoomManagement: {       //直播間管理
        roomType: {
            dedicated: "導播源專用",
            publish: "可發布",
            dedicated_nfplus: "雲導播輸入直播間",
            publish_nfplus: "雲導播輸出直播間",
            dedicatedLiveRoom: "導播源專用直播間",
            publishLiveRoom: "可發布直播間",
            dedicatedLiveRoom_nfplus: "雲導播輸入直播間",
            publishLiveRoom_nfplus: "雲導播輸出直播間",
        },
        liveRoomList: {     //直播間列表
            Button: {
                share: "分享",
                shareDialog: {
                    title: "分享直播間",
                    okText: "打開"
                },
                edit: "編輯",
                vodFlag: {
                    title: "修改狀態",
                    Live: "直播",
                    PlaybackOpen: "回顧開啟",
                    PlaybackClose: "回顧關閉",
                    Trailer: "預告"
                },
                publish: {
                    title: "頁面發布",
                    issue: "發布",
                    close: "撤稿",
                },
                liveUrl: "獲取直播地址",
                liveUrlDialog: {
                    title: "獲取直播地址",
                    hls: "直播HLS地址：",
                    rtmp: "直播RTMP地址："
                },
                wordLive: "圖文直播",
                relatedReport: "相關報道",
                createRelatedReport: "生成相關報道",
                editRelatedReport: "更新相關報道",
                commentManagement: "評論互動",
                realEditor: "實時編輯",
                deleteLiveRoom: "刪除",
                error: "{類型錯誤}"
            },
            List: {
                addLiveRoom: "添加直播間",
                filter: {
                    placeholderInput: "搜索",
                    placeholderSelect: "請選擇",
                    roomId: "ID",
                    roomTitle: "名稱",
                    userCode: "賬號名",
                    globalCategoryNameLike: "分類",
                    categoryNameLike: "專題",
                    roomType: "類型",
                    publishStatus: {
                        title: "發布",
                        close: "未發布",
                        issue: "已發布"
                    },
                    status: {
                        title: "推流進展",
                        all: "全部",
                        streamming: "推流中"
                    },
                    userGroupTitle: "用戶組 "
                },
                sortType: {
                    title: "排序方式：",
                    createTime: "創建時間",
                    liveTime: "直播時間"
                },
                displayMode: {
                    title: "顯示模式：",
                    pageSize: {
                        ps10: "10條/頁",
                        ps20: "20條/頁",
                        ps50: "50條/頁",
                        ps100: "100條/頁"
                    }
                },
                forbiddenTag: {
                    title: "禁播原因：",
                    text: "禁播",
                    explainHint: "請聯繫客服"
                },
                pushingTag: "推流中",
                thumbList: {
                    roomId: "ID",
                    userName: "所屬用戶",
                    globalCategoryName: "分類",
                    categoryName: "專題"
                },
                opList: {
                    timeDescription: "直播開始時間：",
                    createRoomTime: "房間創建時間：",
                },
                removeBatch: "批量刪除",
                liveRoomTable: {
                    roomId: "ID",
                    roomTitle: "名稱",
                    userName: "所屬用戶",
                    status: "狀態",
                    roomType: "類型",
                    operation: "操作"
                }
            },
            Edit: {
                liveRoomSettings: {
                    roomTitle: "直播間名稱：",
                    roomType: {
                        title: "直播間類型：",
                        prompt: "提示：導播源專用直播間只能用於雲導播輸入，不可發布",
                        prompt_nfplus: "提示：輸入直播間只能用於雲導播輸入，不可發布",
                        promptSave: "該直播間類型是<b color='red'>慢直播</b>，直播<b color='red'>不會自動錄像</b>，確認保存嗎？",
                    },
                    timeDescription: {
                        title: "直播開始時間：",
                        placeholder: "選擇直播開始時間"
                    },
                    roomDescription: "直播間描述：",
                    paidLive: {
                        title: "是否加密直播：",
                        no: "否",
                        yes: "是"
                    },
                    multiLive: {
                        title: "滚动播放：",
                        no: "关闭",
                        yes: "开启"
                    },
                    discussAuditMechanism: {
                        title: "評論審核機制：",
                        type0: "先審後發",
                        type1: "先發後審"
                    },
                    discussAuditStartDatetime: {
                        title: "先發後審開啟時間：",
                        placeholder: "選擇先發後審開啟時間"
                    },
                    discussAuditEndDatetime: {
                        title: "先發後審關閉時間：",
                        placeholder: "選擇先發後審關閉時間"
                    },
                    globalRoomCategoryId: "直播分類：",
                    liveRoomCategoryId: {
                        title: "直播專題：",
                        none: "無"
                    },
                    backgroundImg: {
                        title: "播放器背景圖：",
                        prompt: "推薦使用：16:9，1280x720，500k"
                    }
                },
                liveRoomRules: {
                    roomTitle: "直播間名稱不能為空",
                    timeDescription: "直播間開始時間不能為空",
                    roomDescription: "直播間描述不能為空",
                }
            },
            Detail: {
                numDialog: {
                    title: "修改點讚數和觀看人數",
                    commendNumDummy: "點讚數：",
                    playCountDummy: "總訪問量："
                },
                Info: {
                    roomTitle: "名稱：",
                    roomID: "ID：",
                    userName: "所屬用戶：",
                    globalCategory: "分類：",
                    category: "專題：",
                    createRoomTime: "創建時間：",
                    timeDescription: "直播開始時間：",
                    roomDescription: "簡介描述：",
                },
                viewPoints: {
                    commendNum: "實際點讚數：",
                    commendNumDummy: "點讚數：",
                    viewNumber: "總訪問量：",
                    playCountMore: "實際訪問總量："
                },
                tabPane: {
                    recordManagement: "點播/回放管理",
                    recordVideo: "錄製",
                    commentManagement: "評論管理",
                    liveRoomPullForwardManagement: "直播源管理",
                    liveRoomPushForwardManagement: "推流輸出管理",
                    transcodeRecord: "錄像合成",
                    livePageManagement: "直播頁管理",
                    sharedExtension: "分享設置",
                    appReportPlayPageAccessDaily: "數據統計",
                    goods: "直播帶貨"
                }
            },
            videoRef: {
                title: "作品列表",
                list: {
                    materialId: "ID",
                    name: "名稱",
                    videoDuration: "時長(s)",
                    preview: "預覽圖",
                    videoLevelCheck: "清晰度選擇",
                }
            }
        },
        liveRoomDetail: {
            recordManagement: {
                uploadDialog: {
                    title: "上傳視頻",
                    button: "點擊選擇視頻"
                },
                editDialog: {
                    title: "編輯錄像信息",
                    recordSettings: {
                        recordId: "錄像ID：",
                        recordName: "錄像名稱：",
                        picUploader: {
                            title: "封面圖：",
                            prompt: "推薦使用：16:9，1280x720，500k"
                        }
                    },
                    recordSettingsRules: {
                        recordName: "錄像名稱不能為空"
                    }
                },
                reviewUrl: {
                    title: "獲取回看地址",
                    label: "hls地址："
                },
                transformDialog: {
                    title: "錄像轉素材",
                    transformSettings: {
                        categoryId: "分類名稱：",
                        name: "錄像名稱："
                    }
                },
                filter: {
                    recordNameLike: "錄像名稱",
                    recordType: {
                        title: "錄像類型",
                        liveVideo: "直播錄像",
                        refVideo: "關聯錄像"
                    },
                    outFlag: {
                        title: "輸出狀態",
                        init: "未輸出",
                        done: "已輸出",
                    },
                    videoDuration: "最短時長"
                },
                prompt: "提示：1.勾選多個錄像時，如需顯示點播列表，請到直播頁管理打開「回顧列表」功能，否則將循環播放，錄像按勾選順序在回顧列表中顯示；2.列表只顯示時長大於6秒的視頻",
                info: {
                    list: {
                        recordId: "錄像ID",
                        recordStatus: "狀態",
                        recordTimes: "時長",
                        createDatetime: "生成時間："
                    },
                    button: {
                        updateRecordOutFlag: "回顧輸出",
                        getPlayAddress: "獲取回看地址",
                        getDownload: "預覽/下載",
                        edit: "編輯",
                        remove: "刪除",
                        transToMat: "錄像轉素材",
                        publishRecord: "入庫",
                    }
                }
            },
            recordVideo: {
                message: {
                    notPushing: "請先開啟推流",
                    start: {
                        success: "錄製開啟成功",
                        error: "錄製開啟失敗"
                    },
                    cancel: {
                        success: "錄製關閉成功",
                        error: "錄製關閉失敗"
                    },
                    click: {
                        start: "點擊開啟錄製",
                        stop: "點擊關閉錄製"
                    },
                    confirm: {
                        start: "確認要開啟錄製嗎？",
                        stop: "確認要停止錄製嗎？"
                    }
                },
                button: {
                    start: "錄製",
                    cancel: "停止錄製",
                    stopped: "未開啟錄製",
                    starting: "錄製中（{time}）"
                },
                title: "視頻錄製",
                list: {
                    liveRecordTaskStatus: "狀態",
                    liveRecordTaskDuration: "錄製時長",
                    liveRecordTaskTranscodeStatus: "轉碼狀態"
                },
                status: {
                    recording: "錄製中",
                    recordStop: "未錄製"
                },
                transcodeStatus: {
                    init: "初始",
                    launching: "啟動中",
                    transcoding: "轉碼中",
                    done: "完成",
                    stop: "停止",
                    error: "出錯",
                },
                prompt: {
                    startTips: "生成的錄像將以該標題命名"
                }
            },
            commentManagement: {
                message: {
                    prohibited: "發布失敗，評論含有違禁詞",
                    remove: {
                        confirm: "確認刪除該評論？",
                        batchEmpty: "請選擇要刪除的評論",
                        batchConfirm: "確認刪除所選評論？"
                    },
                    updateBatch: {
                        publishEmpty: "請選擇要發布的評論",
                        shieldEmpty: "請選擇要屏蔽的評論",
                        publishConfirm: "確認發布所選評論？",
                        shieldConfirm: "確認屏蔽所選評論？",
                        publishSuccess: "發布成功",
                        shieldSuccess: "屏蔽成功",
                        publishError: "發布失敗",
                        shieldError: "屏蔽失敗",
                    }
                },
                button: {
                    batchOperation: "批量操作",
                    updateBatchPublish: "批量發布",
                    updateBatchShield: "批量屏蔽",
                    removeBatch: "批量刪除",
                    publish: "發布",
                    shield: "屏蔽"
                },
                filter: {
                    discussContentLike: {
                        title: "評論內容",
                        poptipContent: "請至少輸入兩個字"
                    },
                    refreshTimeList: {
                        second10: "10秒",
                        second30: "30秒",
                        minute1: "1分鐘",
                        minute3: "3分鐘",
                        minute5: "5分鐘"
                    }
                }
            },
            liveRoomPullForwardManagement: {
                button: {
                    selectFromLive: "從直播平台選",
                    selectFromMaterial: "從素材中心選",
                    clickClose: "點擊關閉",
                    clickStart: "點擊開始",
                    remove: '移除'
                },
                message: {
                    checkPullUrl: "請填寫正確的rtmp或hls地址",
                    switchLiving: "直播間正在直播中，若要修改直播源，請先停止當前直播",
                    closeConfirm: "此操作會關閉當前直播，確定執行嗎？",
                    startConfirm: "是否確認開啟直播？",
                    saveLivingConfirm: "直播間正在直播中，修改直播源會導致直播中斷，是否確認保存？",
                    outputParamEmpty: "請選擇參數",
                    fileEmpty: "請選擇文件",
                    placeholderPull: "請填寫直播rtmp或m3u8播放地址",
                    whitelistTitle: "使用白名單節點拉流",
                    whitelistTip1: "直播流提供方要求提供拉流IP時勾選此項",
                    whitelistTip2: "並聯繫系統管理員獲取拉流IP"
                },
                prompt: {
                    title: "提示：",
                    prompt1: "設置拉流/推流/文件直播源後，需要<b style='color:red'>點擊保存才生效。</b>",
                    prompt2: "請填寫直播<b style='color:red'>rtmp、m3u8或rtsp</b>播放地址",
                    director: "提示：如需使用雲導播作為源，請到雲導播直接輸出到此直播間",
                    roomStatusDialogTitle: "狀態控制",
                    roomStatusDialogVodFlagLabel: "狀態",
                    recordTips: "提示：慢直播間直播<b style='color:red'>不會自動錄像</b>。請使用錄製功能或預約錄製功能來錄像。"
                },
                taskType: {
                    title: "直播源類型：",
                    pull: "拉流",
                    push: "推流",
                    file: "文件",
                    director: "雲導播"
                },
                address: {
                    title: "流地址：",
                    prompt: "30分鐘直播地址無效，自動關閉",
                    promptExpire: "推流地址到期時間為："
                },
                outputParam: "參數：",
                fileloopFlag: {
                    title: "是否循環：",
                    no: "否",
                    yes: "是"
                },
                fileList: {
                    title: "文件列表：",
                    prompt: "提示：播放列表以按點擊順序排列",
                    select: "選擇",
                    materialId: "ID",
                    name: "名稱",
                    videoDuration: "時長(s)",
                    operation: "操作",
                    userCode: "所屬用戶"
                }
            },
            liveRoomPushForwardManagement: {
                message: {
                    checkRtmpURL: "請輸入正確的rtmp地址"
                },
                pushList: {
                    pushId: "序號",
                    roomMultiStreamFlag: "類型",
                    pushName: "名稱",
                    parameter: "推流參數",
                    status: "狀態",
                    streammingStatus: "推流狀態",
                    operation: "操作",
                },
                roomMultiStreamFlag: {
                    rmsf0: "對外推流",
                    rmsf1: "直播間轉碼",
                    rmsf2: "CDN推流"
                },
                status: {
                    start: "開啟",
                    close: "關閉"
                },
                pushForwardSettings: {
                    roomMultiStreamFlag: "類型：",
                    pushName: "名稱：",
                    status: "狀態：",
                    pushUrl: "rtmp推流地址：",
                    pushTranscodeParam: {
                        title: "推流轉碼參數：",
                        standardDefinition: "標清(640x360 20fps 500kbps+64kbps)",
                        highDefinition: "高清(960x540 25fps 800kbps+96kbps)",
                        superDefinition: "超清(1280x720 25fps 1000kbps+96kbps)",
                        blueRay: "藍光(1920x1080 25fps 3000kbps+128kbps)",
                    }
                },
                pushForwardRules: {
                    pushName: "名稱不能為空"
                },
                streammingStatus: {
                    init: "無",
                    launching: "啟動中",
                    pushing: "推流中",
                    stop: "停止",
                    error: "錯誤"
                }
            },
            transcodeRecord: {
                message: {
                    recordNameEmpty: "合成錄像名稱不能為空",
                    start: {
                        success: "合成任務啟動成功，合成需要一定的時間，請耐心等待！",
                        info: "錄像合成未關聯錄像，請先關聯錄像再啟動"
                    },
                    control: {
                        add: {
                            success: "添加成功",
                            error: "添加失敗"
                        },
                        remove: {
                            success: "移除成功",
                            error: "移除失敗"
                        }
                    },
                    remove: "該記錄對應的錄像也將被刪除，確認刪除嗎？"
                },
                button: {
                    play: "播放",
                    relevance: "關聯",
                    sort: "排序",
                    start: "啟動"
                },
                editDialog: {
                    title: "合成錄像",
                    recordName: "錄像名稱："
                },
                videoPlayer: { title: "視頻播放器" },
                transcodeList: {
                    transcodeRecordId: "序號",
                    transcodeRecordName: "名稱",
                    status: "狀態",
                    operation: "操作"
                },
                recordDialog: {
                    title: "錄像列表",
                    filter: { recordNameLike: "錄像名稱：" }
                },
                recordTable: {
                    relevance: "關聯",
                    recordName: "錄像名稱",
                    info: {
                        title: "格式信息",
                        videoDimension: "分辨率：",
                        videoFps: "幀率：",
                        videoBitrate: "視頻碼率：",
                        audioBitrate: "音頻碼率：",
                        audioSampleRate: "音頻採樣率：",
                    },
                    recordTimes: "錄像時長(s)",
                    createDatetime: "生成時間",
                },
                sortDialog: {
                    title: "錄像排序",
                    prompt: "提示：拖拽表格某一行進行排序"
                },
                sortTable: {
                    index: "序號",
                    recordName: "錄像名稱",
                    recordTimes: "錄像時長(s)",
                    recordDatetime: "生成時間",
                }
            },
            livePageManagement: {
                livePageSettings: {
                    changePublicPageTemplate: "確認要修改發布頁模板嗎?",
                    publicPageTemplateDefalue: "默認模板",
                    publicPageTemplateCustom: "自定義直播間模板",
                    publicPageTemplate: "發布頁模板：",
                    tabName: "欄目名稱：",
                    wordLiveTabName: "圖文直播：",
                    discussTabName: "評論互動：",
                    extendContentTabName: "相關報道菜單：",
                    recordTabName: "回顧列表：",
                    isPublic: "觀看密碼：",
                    appDownload: "APP下載：",
                    appDownloadUrl: "鏈接：",
                    password: {
                        title: "密碼：",
                        prompt: "如不填則系統自動生成,最少6位"
                    },
                    control: {
                        title: "功能控制：",
                        liveVideo: "視頻直播",
                        likeButton: "點讚按鈕",
                        likeNumber: "點讚次數",
                        viewNumber: "訪問次數",
                        appDownload: "APP下載",
                        danmu: "彈幕",
                        liveHighlight: "精彩瞬間",
                    },
                    gift: {
                        title: "選擇禮物："
                    },
                    isPortrait: "豎屏直播",
                    viewWelPage: "歡迎頁面顯示：",
                    uploadWelPage: {
                        title: "上傳歡迎頁圖：",
                        mobile: {
                            title: "手機",
                            promptHead: "推薦使用：",
                            promptTrail: "9:16，750x405，200k"
                        },
                        pc: {
                            title: "電腦",
                            promptHead: "推薦使用：",
                            promptTrail: "16:9，1280x720，500k"
                        },
                        prompt: "提示：為兼容不同分辨率的顯示器，圖片會等比拉伸填充屏幕後居中顯示"
                    },
                    outerChain: {
                        title: "氣泡按鈕：",
                        urlTitle: "鏈接：",
                        imgTitle: "氣泡按鈕圖片：",
                        uploadImg: "上傳圖片",
                        tip: "推薦使用：1:1，64x64的圓形圖標"
                    },
                    goods: {
                        title: "直播帶貨："
                    },
                    staticJsonFile: {
                        button: {
                            create: "生成靜態 ",
                            update: "更新靜態",
                            remove: "刪除靜態"
                        },
                        message: {
                            createSuccess: "生成成功",
                            updateSuccess: "更新成功",
                            removeSuccess: "刪除成功",
                        }
                    }
                },
                livePageSettingsRule: {
                    urlRequired: "請填寫氣泡按鈕鏈接",
                    urlInvalid: "請填寫正確的URL鏈接",
                    passwordMin: "密碼必須大於等於6位",
                    giftMin: "禮物至少選擇1個"
                },
                previewType: {
                    title: "預覽（需要先保存）：",
                    mobile: "手機",
                    app: "APP",
                    pc: "電腦"
                }
            },
            shareExtension: {
                button: {
                    clear: "恢復默認"
                },
                shareRoomSettings: {
                    isShowprefix: "顯示前綴：",
                    sharePrefix: "標題前綴：",
                    shareTitle: "標題內容：",
                    shareDesc: "副標題內容：",
                    shareImg: {
                        title: "分享圖標",
                        prompt: "推薦使用：1:1，250x250，50k"
                    }
                },
                preview: {
                    title: "預覽（微信分享）：",
                    playTrailer: "直播預告：",
                    playBack: "直播中：",
                    playing: "直播回放：",
                },
                clearDialog: {
                    title: "恢復默認",
                    content: "恢復默認設置將刪除現有的設置，確認要刪除嗎？"
                }
            },
            appReportPlayPageAccessDaily: {
                type: {
                    type1: "觀看數據",
                    type2: "用戶區域分布（全國）",
                    type3: "用戶區域分布（廣東）",
                    type4: "訪問終端分布",
                    type5: "訪問渠道分布",
                    type6: "觀看次數",
                    type7: "直播在線人數"
                },
                time: { placeholder: "選擇日期" },
                timeRange: { placeholder: "選擇日期區間" },
                series: "人數",
                optionPV: "頁面訪問次數",
                optionUV: "頁面訪問用戶數",
                optionPLAY: "視頻播放次數",
                option3: "用戶區域分布（廣東）",
                option2: "用戶區域分布（全國）",
                option4: "訪問終端分布",
                option5: {
                    title: "訪問渠道分布",
                    data: {
                        terminal: "客戶端",
                        microMessage: "微信",
                        other: "其他"
                    }
                },
                option6: {
                    title: "觀看次數",
                    data: {
                        one: "1次",
                        two: "2次",
                        three: "3次",
                        four: "4次",
                        five: "5次",
                        sixToNine: "6-9次",
                        tenToHundred: "10-100次",
                        moreThanHundred: "100次以上",
                    }
                },
                option7: "直播在線人數"
            },
            goodsManagement: {
                goods: {
                    productName: "商品名稱",
                    productLink: "鏈接地址",
                    productPlatform: "購物平台",
                    productTicket: "分享口令",
                    productDescribe: "商品簡介",
                    productImg: "商品圖片",
                    price: "商品價格（元）",
                    salesPrice: "折後價格（元）",
                    sortOrder: "排序序號",
                    state: "狀態",
                    platformPresets: "淘寶#天貓#京東#蘇寧易購#拼多多"
                },
                list: {
                    productLink: "鏈接地址",
                    productPlatform: "購物平台",
                    productTicket: "分享口令",
                    productDescribe: "商品簡介",
                    productImg: "商品圖片",
                    salesPrice: "折後價格",
                },
                filter: {
                    productNameLike: "商品名稱"
                },
                goodsRules: {
                    productName: "請填寫商品名稱",
                    productLink: "請填寫正確的鏈接地址",
                    productPlatform: "請填寫購物平台",
                    productTicket: "請填寫分享口令",
                    productDescribe: "請填寫商品簡介",
                    productImg: "請上傳商品圖片",
                    price: "商品價格應為正整數、小數且大於0,保留兩位小數",
                    salesPrice: "折後價格應為正整數、小數且大於0小於商品價格,保留兩位小數",
                    sortOrderType: "排序序號取值範圍為0-65535",
                },
                button: {
                    offline: "下架",
                    online: "上架"
                },
                tip: {
                    productTicket: "淘寶的淘口令等",
                    productImg: "推薦使用1:1, 120x120, 50k",
                },
                message: {
                    updateStateConfirm: "確認要{state}商品嗎？"
                }
            },
            multiLiveManage: {
                syncRoomImage: "同步直播間封面"
            }
        },
        liveCategory: {
            message: {
                categoryNameEmpty: "專題名稱不能為空"
            },
            button: {
                addCategory: "添加專題",
                refLiveRoom: "關聯直播間列表",
            },
            dialog: {
                title: "直播專題",
                name: "專題名稱："
            },
            filter: { nameLike: "名稱" },
            list: {
                id: "序號",
                name: "名稱",
                createDatetime: "創建時間",
                operation: "操作",
            }
        },
        relatedReport: {
            List: {
                message: {
                    remove: { confirm: "相關報道已被添加到圖文直播里，繼續刪除嗎？" }
                },
                button: {
                    addRelatedReport: "添加相關報道"
                },
                filter: {
                    titleLike: "標題",
                    userCode: "賬號名"
                },
                list: {
                    id: "ID",
                    userName: "所屬用戶",
                    url: "URL",
                    status: {
                        title: "狀態",
                        normal: "正常",
                        forbidden: "禁用",
                    },
                    publishDatetime: "發布時間",
                }
            },
            Detail: {
                message: {
                    checkTime: "請選擇發布日期",
                    checkURL: "請輸入正確的url地址",
                    save: { confirm: "修改後會影響到（title）圖文直播,是否保存？" }
                },
                relatedReportSettings: {
                    title: "標題：",
                    imagePath: {
                        title: "圖片：",
                        prompt: "推薦使用：16:9，250x140，50k"
                    },
                    url: "鏈接url：",
                    status: {
                        title: "狀態：",
                        normal: "有效",
                        forbidden: "無效",
                    },
                    publishDatetime: {
                        title: "發布時間：",
                        placeholder: "相關報道發布時間"
                    },
                    description: "簡介：",
                },
                relatedReportRules: { title: "標題不能為空" }
            }
        },
        liveRecord: {
            filter: {
                roomId: "直播間ID",
                roomTitleLike: "標題",
                userCode: "賬號名",
                liveStatus: {
                    title: "狀態",
                    live: "直播中",
                    timeout: "超時結束"
                }
            },
            list: {
                userName: "所屬用戶",
                id: "直播任務ID",
                roomId: "直播間ID",
                liveName: "直播記錄名稱",
                liveTime: "直播時長(s)",
                isRecord: {
                    title: "是否有錄像",
                    yes: "是",
                    no: "否",
                },
                clientIp: "客戶端IP",
                beginTime: "開始時間",
                endTime: "結束時間",
                liveStatus: {
                    title: "狀態",
                    start: "啟動中",
                    streamming: "直播中",
                    end: "結束",
                    timeout: "超時結束",
                    error: "出錯"
                }
            }
        }
    },
    MaterialManagement: {       //素材管理
        List: {
            message: {
                topicNameEmpty: "素材名稱不能為空",
                remove: { error: "刪除失敗，素材分類含有素材" }
            },
            button: {
                addTopic: "添加分類",
                manege: "素材管理"
            },
            dialog: {
                title: "素材分類",
                topicName: "分類名稱："
            },
            filter: {
                topicName: "名稱",
                userCode: "賬號名"
            },
            list: {
                topicId: "序號",
                topicName: "分類名稱",
                createDatetime: "創建時間",
                userName: "所屬用戶",
                operation: "操作"
            }
        },
        Material: {
            message: {
                nameEmpty: "名稱不能為空",
                publish: {
                    confirm: "確認要發布該視頻嗎",
                    confirmAgain: "該操作會生成新的發布記錄,確認要重新發布該視頻嗎?",
                }
            },
            button: {
                uploadMaterial: "上傳素材"
            },
            uploadDialog: {
                title: "上傳素材",
                prompt: "點擊或者拖動文件到這裡上傳",
            },
            editDialog: {
                title: "素材編輯",
                name: "素材名稱："
            },
            filter: {
                name: "名稱",
                type: {
                    title: "作品類型",
                    video: "視頻",
                    audio: "音頻",
                    image: "圖片"
                }
            },
            list: {
                userName: "所屬用戶",
                topicName: "分類",
                status: "狀態",
                publishStatus: "發布狀態",
                createDatetime: "創建時間"
            }
        }
    },
    WatermarkManagement: {
        position: {
            leftTop: "左上",
            leftBottom: "左下",
            rightTop: "右上",
            rightBottom: "右下",
            alignCenter: "居中",
            bespread: "鋪滿"
        },
        type: {
            image: "圖片",
            text: "文字",
        },
        List: {
            button: {
                add: "添加水印",
            },
            filter: {
                watermarkName: "水印名稱",
                userCode: "賬號名",
                type: "類型"
            },
            list: {
                userName: "所屬用戶",
                imagePath: "查看圖片",
                words: "文本內容",
                position: "位置",
                opacityPercent: "透明度"
            }
        },
        Detail: {
            watermarkSettings: {
                watermarkName: "水印名稱：",
                position: "位置：",
                watermarkType: "類型：",
                isDefault: {
                    title: "是否默認：",
                    yes: "是",
                    no: "否"
                },
                opacityPercent: "透明度：",
                zoomPercent: "縮放：",
                imagePath: {
                    title: "圖片",
                    prompt: "推薦使用：寬度不大於1280"
                },
                words: "文字：",
                fontSize: "文字大小：",
                fontColor: "文字顏色：",
                fontFamily: "文字字體："
            },
            watermarkSettingsRules: {
                watermarkName: "請輸入水印名稱",
                words: "請輸入文字",
                fontSize: "請輸入文字大小"
            }
        }
    },
    directorManagement: {
        director: {
            button: {
                add: "添加雲導播任務",
                allAdd: "添加雲導播任務",
                slowAdd: "添加慢直播導播任務",
                vrAdd: "添加VR導播任務",
                directorControl: "導播控制台",
                directorMonitor: "導播監控台"
            },
            type: {
                auto: "自動停止",
                manual: "手動停止"
            },
            mode: {
                common: "普通",
                vr: "VR",
                slowLive: "慢直播"
            },
            status: {
                initing: "創建中",
                init: "初始",
                start: "啟動",
                stop: "停止"
            },
            editDialog: {
                title: "編輯雲導播",
                name: "名稱：",
                type: "類型：",
                mode: "模式：",
                tip: "提示：",
                prompt: "提示：直播結束後，請關閉雲導播釋放平台資源。",
                prompt1: "1.雲導播在沒有輸出、無活動輸入源狀態下關閉控制台後，半小時自動回收;",
                prompt2: "2.雲導播在沒有輸出、有活動輸入源狀態下關閉控制台後，12小時自動回收。",
                promptAuto: "1.自動停止：當全部輸入源不可用時，系統自動停止",
                promptManual: "2.手動停止：系統不會自動停止",
            },
            filter: {
                nameLike: "名稱",
                userCode: "賬號名",
                status: "狀態"
            },
            list: {
                id: "序號",
                name: "名稱",
                type: "類型",
                status: "狀態",
                createDatetime: "創建時間",
                userName: "所屬用戶",
                operation: "操作"
            },
            directorRules: { name: "名稱不能為空" }
        },
        departmentTemplate: {
            button: { add: "添加模版" },
            filter: { nameLike: "名稱" },
            list: {
                id: "ID",
                depName: "所屬部門",
                userName: "創建者",
                createDatetime: "創建時間"
            }
        },
        materialTemplate: {
            button: { add: "添加模版" },
            filter: {
                nameLike: "名稱",
                userCode: "賬號名"
            },
            list: {
                id: "ID",
                userName: "創建者",
                createDatetime: "創建時間"
            }
        }
    },
    cloudEditor: {
        List: {
            button: {
                add: "添加雲編輯任務",
                simple: "簡易",
                professional: "專業",
                outputTask: "輸出任務",
            },
            editDialog: {
                title: "雲編輯記錄",
                cloudEditorSettings: { title: "雲編輯標題：" }
            },
            filter: {
                titleLike: "名稱",
                userCode: "賬號名"
            },
            list: {
                id: "序號",
                title: "名稱",
                createDatetime: "創建時間",
                userName: "所屬用戶",
                operation: "操作"
            }
        },
        OutputTask: {
            message: {
                stopTask: {
                    confirm: "確認停止任務",
                    success: "任務(title)已停止",
                    error: "任務(title)停止失敗"
                }
            },
            filter: { nameLike: "名稱" },
            list: {
                id: "名稱",
                outputTaskName: "名稱",
                roomTitle: "直播間",
                status: {
                    title: "狀態",
                    queuing: "排隊中",
                    starting: "啟動中",
                    pause: "暫停",
                    transcoding: "轉碼中",
                    done: "完成",
                    stop: "停止",
                    error: "錯誤"
                },
                createDatetime: "創建時間",
                userName: "所屬用戶",
                operation: "操作"
            }
        }
    },
    realEditor: {
        List: {
            button: {
                add: "添加實時編輯任務",
                controlPanel: "控制台"
            },
            status: {
                init: "初始",
                running: "運行中",
                error: "出錯",
                close: "關閉",
                pastDue: "過期",
                stop: "停止"
            },
            editDialog: {
                title: "實時編輯記錄",
                name: "實時編輯標題：",
            },
            filter: {
                titleLike: "名稱",
                userCode: "賬號名",
                status: "狀態"
            },
            list: {
                id: "序號",
                name: "名稱",
                status: "狀態",
                createDatetime: "創建時間",
                userName: "所屬用戶",
                operation: "操作"
            }
        }
    },
    virtualOfficeManagement: {
        virtualOffice: {
            List: {
                button: {
                    add: "添加雲演播任務",
                    controlPanel: "控制台"
                },
                status: {
                    init: "初始",
                    start: "啟動",
                    stop: "停止"
                },
                editDialog: {
                    title: "雲演播記錄",
                    name: "雲演播名稱："
                },
                filter: {
                    titleLike: "名稱",
                    userCode: "賬號名",
                    status: "狀態"
                },
                list: {
                    id: "名稱",
                    name: "賬號名",
                    status: "狀態",
                    createDatetime: "創建時間",
                    userName: "所屬用戶",
                    operation: "操作"
                }
            }
        },
        virtualOfficeTemplate: {
            List: {
                button: {
                    add: "添加模板",
                    management: "管理"
                },
                filter: {
                    templateNameLike: "名稱",
                    userCode: "用戶名"
                },
                list: {
                    id: "名稱",
                    userName: "用戶名",
                    templateDimension: "分辨率",
                    createDatetime: "創建時間"
                },
                copyDialog: {
                    title: "模板名稱：",
                    templateName: "模板名稱：",
                    copyBtn: "複製模版"
                }
            },
            Detail: {
                virtualOfficeTemplateSettings: {
                    templateName: "直播間名稱：",
                    templateDimension: "分辨率：",
                    backgroundPath: {
                        title: "封面圖：",
                        prompt: "推薦使用：16:9，1280x720，500k"
                    }
                },
                virtualOfficeTemplateRules: {
                    templateName: "名稱不能為空"
                }
            }
        }
    },
    hardEncoder: {
        encoderStreamType: {
            old: "舊版",
            newM: "新版主碼流",
            newC: "新版子碼流"
        },
        runStatus: {
            disconnect: "斷開",
            standBy: "待機",
            pushStart: "開始推流",
            pushing: "推流中",
            error: "出錯",
            pushStop: "停止推流"
        },
        useStatus: {
            normal: "正常",
            forbidden: "禁用"
        },
        List: {
            message: {
                startPush: {
                    confirm: "您確定要開啟此編碼器/攝像頭嗎？",
                    success: "啟動成功",
                    error: "啟動失敗",
                },
                stopPush: {
                    confirm: "您確定要停止此編碼器/攝像頭嗎？",
                    success: "停止成功",
                    error: "停止失敗",
                },
                re: {
                    set: "您確定要重置該編碼器嗎？",
                    start: "您確定要重啟該編碼器嗎？",
                    success: "操作成功",
                    error: "操作失敗",
                }
            },
            button: {
                startPush: "開始",
                stopPush: "停止",
                reset: "重置",
                restart: "重啟"
            },
            filter: {
                deviceCodeLike: "設備編號",
                deviceNameLike: "設備名稱",
                userCode: "賬號名"
            },
            list: {
                deviceCode: "設備編號ID",
                deviceName: "設備名稱",
                encoderStreamType: "流類型",
                roomId: "直播間ID",
                roomTitle: "直播間名稱",
                runStatus: "運行狀態",
                useStatus: "使用狀態",
                userName: "所屬用戶",
                operation: "操作"
            }
        },
        Detail: {
            button: { unbind: "解綁" },
            bindDialog: {
                title: "綁定直播間",
                filter: {
                    roomId: "直播間ID",
                    roomTitle: "直播間標題",
                },
                table: {
                    relevance: "關聯",
                    roomId: "直播間ID",
                    roomTitle: "直播間標題",
                }
            },
            hardEncoderSettings: {
                deviceName: "設備名稱：",
                encoderStreamType: "碼流類型：",
                roomId: "綁定直播間：",
                encoderPresets: {
                    title: "推流質量預設：",
                    old: {
                        custom: "自定義",
                        standardDefinition: "標清（16:9 20fps 550kbps+64kbps）",
                        highDefinition: "高清（16:9 20fps 800kbps+64kbps）"
                    },
                    newM: {
                        custom: "自定義",
                        highDefinition: "高清（960x540 16:9 25fps 800kbps+96kbps）",
                        superDefinition: "超清（1280x720 16:9 25fps 1000kbps+96kbps）",
                    },
                    newC: {
                        custom: "自定義",
                        fluencyDefinition: "流暢（480x270 16:9 25fps 350kbps+64kbps）",
                        standardDefinition: "標清（640x360 16:9 25fps 550kbps+64kbps）",
                        highDefinition: "高清（960x540 16:9 25fps 800kbps+96kbps）"
                    }
                },
                encoderLevel: {
                    title: "分辨率：",
                    noCustom: "--不可自定義--",
                },
                videoFps: "碼率：",
                videoBitrate: "幀率：",
                audioBitrate: "音頻碼率：",
                audioSource: {
                    title: "音頻信號源：",
                    digital: "內置",
                    line: "外置",
                },
                audioGain: "音頻增溢："
            },
            hardEncoderRules: {
                deviceName: "請輸入設備名稱",
                roomId: "請綁定直播間"
            }
        }
    },
    Components: {
        ForbiddenSpan: {
            title: "禁播原因：",
            text: "禁播",
            explainHint: "請聯繫客服"
        },
        MaterialFilterBar: {        //篩選框
            title: "篩選：",
            button: {
                packUp: "收起",
                unfold: "展開"
            },
            filter: {
                name: "關鍵字",
                publicStatus: "發布狀態",
                categoryId: "分類",
                status: "素材狀態",
                type: "素材類型",
                topicId: "專題",
                timeRange: {
                    title: "修改時間",
                    placeholder: "選擇日期"
                },
                origin: "來源"
            }
        },
        picturePreviewDialog: {     //圖片查看器
            title: "圖片查看器",
            alt: "圖片加載失敗"
        },
        RoomShareModal: {
            prompt: "注意：本平台不提供高清二維碼，如需高清二維碼建議複製頁面地址到第三方二維碼生成平台進行轉碼（如草料）"
        },
        VideoPreviewDialog: {       //視頻播放器
            button: {
                video: "原始視頻",
                audio: "原始音頻"
            },
            title: "播放器"
        },
        upload: {       //上傳功能
            message: {
                uploadSuccess: "上傳成功",
                uploadPause: "上傳已暫停",
                uploadCancel: "上傳已取消，請重新點擊上傳",
                uploadError: "上傳失敗",
                pauseError: "暫停失敗",
                cancelError: "取消失敗",
                prompt: "提示",
                streamV1Upload: {
                    onExtNameMismatch: "請選擇{ext}格式的文件",
                    onMaxSizeExceed: "請不要選擇超過{size}的文件"
                }
            },
            button: { cleanUploadList: "清理已上傳列表" },
            cutDialog: {
                title: "圖片裁剪",
                onCubeImg: "裁剪",
                onCubeImgAndUpload: "裁剪並上傳"
            },
            upload: {
                prompt: {
                    videoFormat: "視頻支持格式：",
                    resolution: "建議分辨率：",
                    audioFormat: "音頻支持格式：",
                    imageFormat: "圖片支持格式：",
                    fileSize: "文件大小：{size}以內",
                    videoFileSize: "視頻文件大小：{size}以內",
                    audioFileSize: "音頻文件大小：{size}以內",
                    imgFileSize: "圖片文件大小：{size}以內",
                },
                imageToVideo: {
                    checkbox: "圖片轉視頻",
                    prompt: "（勾選後，上傳除gif外的圖片時，轉成60秒視頻）",
                },
                vrFlag: {
                    checkbox: "VR視頻",
                    prompt: ""
                }
            },
            uploadLiveRoomPic: {
                type: {
                    across: "橫屏播放器背景圖",
                    vertical: "豎屏播放器背景圖"
                },
                prompt: "註：豎屏直播請務必選擇豎屏播放器背景圖"
            },
            uploadVid: {
                button: {
                    upload: "上傳",
                    pause: "暫停",
                    cancel: "取消上傳",
                }
            }
        }
    }
}